// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_2f-0";
export var colorSwatch = "_2f-5";
export var fillWidth = "_2f-4";
export var iconButton = "_2f-2";
export var iconWrapper = "_2f-3";
export var shadow = "_2f-6";
export var xs = "_2f-1";